import { render, staticRenderFns } from "./NewRestaurant.vue?vue&type=template&id=6e59f95e&"
import script from "./NewRestaurant.vue?vue&type=script&lang=ts&"
export * from "./NewRestaurant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports